<template>

  <div>
    
    <div v-if="permissions.includes('manage_candidates')">
      <div
        v-if="!selectedJob"
        class="alert alert-warning">
        {{ $t('To add a note, select a job') }}
      </div>

      <div
        v-if="selectedJob"
        class="card">
        <div class="card-body">
          <CandidateNoteForm
            :initValue="{}"
            @created="created" />
        </div>
      </div>
      
    </div>

    <CandidateFeed :activityType="'note'" />

  </div>

</template>

<script>
import CandidateNoteForm from './CandidateNoteForm'
import CandidateFeed from '../Feed/CandidateFeed'

export default {
  name: 'CandidateNote',
  components: {
    CandidateNoteForm,
    CandidateFeed
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
    created (note) {
      return this.$store.dispatch('refreshSelectActivities')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Note/CandidateNote.vue